import React from 'react';
import style from '../../../PaperworkList/PaperworkList.module.css';
import s from '../CashOrdersList.module.css';

import {CashierOrderType} from '../../../../types/CashierSliceStateType';
import CashierTableActions from './CashierTableActions';
import {useTranslation} from 'react-i18next';

type Props = {
	order: CashierOrderType;
};

const CashOrderTableElement: React.FC<Props> = ({order}) => {
	const {t} = useTranslation();
	const {id, order_date, amount, status, comment} = order;
	const statusMap = {
		new: t('Новий'),
		approved: t('Підтверджено'),
		rejected: t('Видалено'),
		working: t('Оброблюється'),
	} as const;

	type Status = 'new' | 'approved' | 'rejected' | 'working';

	const statusName = statusMap[status as Status] ?? '';
	return (
		<div className={`${style.tableRow} ${s.tableRow}`}>
			<div className={style.tableColumn}>{id}</div>
			<div className={style.tableColumn}>{order_date}</div>
			<div className={style.tableColumn}>{amount}</div>
			<div className={style.tableColumn}>{statusName}</div>
			<div className={`${style.tableColumn} ${style.comment}`}>{comment}</div>
			<CashierTableActions order={order} />
		</div>
	);
};

export default CashOrderTableElement;
